(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-prototype-journey"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){const input=event.target;if(!input.matches('.cc-proto-design-option input'))return;const scope=input.closest('.cc-proto-designs');scope.querySelector('[data-cc-design-selection]').textContent=input.dataset.designName;const link=scope.querySelector('[data-cc-design-link]');if(link){const url=new URL(link.href);url.searchParams.set('variant',input.value);link.href=url.toString();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-video-disc-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cc-disc-stack'))customElements.define('cc-disc-stack',class extends HTMLElement{
connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';this.current=0;this.panels=[...this.querySelectorAll('[data-disc-panel]')];this.addEventListener('click',e=>{const pick=e.target.closest('[data-pick]'),step=e.target.closest('[data-step]');if(pick)this.select(Number(pick.dataset.pick));if(step)this.select(this.current+Number(step.dataset.step));});}
select(index){this.current=(index+this.panels.length)%this.panels.length;this.panels.forEach((p,i)=>p.hidden=i!==this.current);this.querySelectorAll('[data-pick]').forEach((b,i)=>b.setAttribute('aria-pressed',String(i===this.current)));const counter=this.querySelector('[data-counter]');if(counter)counter.textContent=(this.current+1)+' / '+this.panels.length;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
